/**
 * Callout sidebar UI component
 * @param  data 
 * @returns 
 * data : Array
 * callout : array
 * callout.title : string
 * callout.content : rawHtml string
 * 
 */ 

import React from "react"
function SidebarCallout(data) {
    if(data.data !== null) {
        const callouts = data.data.map((callout) => {
          return (
            <div className="callout-sidebar">
            <div className="element--inner--btop">
                <div className="element--inner">
                    <p className="heading callout__heading">{callout.title}</p>
                    <div className="callout--linktext" dangerouslySetInnerHTML={{__html: callout.content}} />
                </div>
            </div>
        </div>
          )
      }
      );
      return(
        <div className="callouts">
            {callouts}
        </div>
      )
    } else {
      return null
    }
}
export default SidebarCallout